import React, { createContext, useContext } from 'react';
import { useAzureAuth } from '../hooks/useAzureAuth';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const authData = useAzureAuth();
  
  return (
    <AuthContext.Provider value={authData}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};